import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { SectionContainer } from "../../styled/StyledComponents";
import { secondsToTimeString } from "@utils/index";
import { FruProButton } from "@components";

const useStyles = makeStyles((theme) => ({
  bgImage: {
    width: 200,
    height: 200,
    margin: "auto",
    background:
      "url('/static/images/backgrounds/email-successful.png') center center no-repeat",
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    padding: "52px 0 24px",
  },
  desc: {
    fontSize: 20,
    paddingBottom: 52,
    maxWidth: 443,
    margin: "auto",
  },
  customButton: {
    backgroundColor: `${theme.palette.initial.main} !important`,
    border: `1px solid ${theme.palette.primary.primaryB} !important`,
    width: 420,
  },
}));

export default function ResendEmail({
  user,
  onSendVerificationEmail,
  shouldCount,
  isLoading,
  second,
}) {
  const classes = useStyles();



  return (
    <SectionContainer className={classes.root}>
      <Box paddingTop="133px">
        <Box className={classes.bgImage}></Box>
        <Typography className={classes.title} align="center">
          Verify your email
        </Typography>
        <Typography className={classes.desc} align="center">
          We sent a verification email to{" "}
          <span className="fw-bold">{user?.email}.</span> Please tap the link
          inside that email to continue
        </Typography>
        {shouldCount && (
          <Typography align="center" style={{ marginBottom: 8 }}>
            {secondsToTimeString(second)}
          </Typography>
        )}
        <Box width="100%" className="flex-center" paddingBottom="71px">
          <FruProButton
            className={classes.customButton}
            radius="20px"
            noMargin
            fontSize={16}
            textColor="#FC932B"
            onClick={() => onSendVerificationEmail({ isResend: true })}
            disabled={(!!second && shouldCount) || isLoading}
          >
            Resend
          </FruProButton>
        </Box>
      </Box>
    </SectionContainer>
  );
}
